import React from 'react';
import useAuthStore from '../stores/authStore';
import ContributorDashboard from '../components/dashboards/ContributorDashboard';
import AdminDashboard from '../components/dashboards/AdminDashboard';

const HomePage: React.FC = () => {
  const { user } = useAuthStore();

  if (!user) {
    return <div>Loading...</div>; // Or a proper loading spinner
  }

  const isContributor = user.role?.toLowerCase() === 'contributor';

  return (
    <div>
      {isContributor ? <ContributorDashboard /> : <AdminDashboard />}
    </div>
  );
};

export default HomePage;